export default "__VITE_ASSET__BkdM0Jci__"